import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "f96f35d0-9ce3-4879-8c8b-1e73ea4f9fef", content: "A<sub>1</sub>", options: {} },
  { id: "4aa3616d-b15c-41c4-b917-ed906dd17e9f", content: "B<sub>1</sub>", options: {} },
  { id: "ad1ed672-e225-4aed-a507-6b116b7948af", content: "A<sub>2</sub>", options: {} },
  { id: "d9c68f49-d070-48b5-8dc3-1823fe8e4f55", content: "B<sub>2</sub>", options: {} },
  { id: "e124c825-1e5e-4372-babb-f1268b900a70", content: "A<sub>3</sub>", options: {} },
  { id: "d34aa737-4334-4fbc-9c6b-1bd27ea2e4f7", content: "B<sub>3</sub>", options: {} },
];

const groups = [
  { id: "b839b523-450b-4651-b018-16e6bef729ee", content: "6.4 dB", options: {} },
  { id: "c51b5286-733e-4961-a54c-041f6224db53", content: "7.3 dB", options: {} },
  { id: "da60ea8f-7d86-403f-bc49-0806f5f295cc", content: "9.2 dB", options: {} },
  { id: "b4a3ac8c-10c2-4033-b561-42c452fd54f0", content: "10.8 dB", options: {} },
  { id: "983a743f-0644-46f0-b832-eb4360cf6a3c", content: "13.2 dB", options: {} },
  { id: "5a21c521-7781-480f-8bfd-7dfe8ec7b323", content: "15.8 dB", options: {} },
];

export const task: Task = {
  id: "1d65af6e-60b0-4147-bb0d-1c06c8624778",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: false,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "b839b523-450b-4651-b018-16e6bef729ee", itemsId: ["f96f35d0-9ce3-4879-8c8b-1e73ea4f9fef"] },
    { groupId: "c51b5286-733e-4961-a54c-041f6224db53", itemsId: ["4aa3616d-b15c-41c4-b917-ed906dd17e9f"] },
    { groupId: "da60ea8f-7d86-403f-bc49-0806f5f295cc", itemsId: ["ad1ed672-e225-4aed-a507-6b116b7948af"] },
    { groupId: "b4a3ac8c-10c2-4033-b561-42c452fd54f0", itemsId: ["d9c68f49-d070-48b5-8dc3-1823fe8e4f55"] },
    { groupId: "5a21c521-7781-480f-8bfd-7dfe8ec7b323", itemsId: ["e124c825-1e5e-4372-babb-f1268b900a70"] },
    { groupId: "983a743f-0644-46f0-b832-eb4360cf6a3c", itemsId: ["d34aa737-4334-4fbc-9c6b-1bd27ea2e4f7"] },
  ],
};
